import React, { Component } from 'react'

import  NoticiasContent  from "../../components/NoticiasContent/NoticiasContent";
import { ConsultPublicaciones } from "../../funciones/PublicacionesFunction";

class Publicacion extends Component {
    state = {
        publicaciones: []
    }

    constructor(props) {
        super(props);
        
        ConsultPublicaciones ((resp) => {
            this.setState({
                publicaciones: resp
            })
        })
    }

    contentPub = () => {
        let { publicaciones } = this.state;

        if (publicaciones.length === 0) return (
            <div className="text-muted" align="center" style={{fontSize:12}}>No se han publicado noticias.</div>
        )

        return (
            publicaciones.map (option => (
                <NoticiasContent
                    key = {option.id}
                    titulo = {option.title}
                    fecha = {option.date}
                    comentarios = {option.views}
                    content= {option.data_content}
                    autor = {`${option.nombre_1} ${option.apellido_1}`}
                />
            ))
        )
    }

    render() { 
        return (
            <React.Fragment>
                <div className="custom-alert-info custom-mt-10" style ={{marginBottom: 10}}>Publicaciones recientes</div>
                {this.contentPub()}
            </React.Fragment>
        );
    }
}
 
export default Publicacion;


// WEBPACK FOOTER //
// ./src/views/Noticias/Publicacion.jsx